<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <app-bar :title="`Cập nhật dung lượng`" />
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card>
            <v-toolbar card color="white">
              <v-btn outline round color="primary" @click="pickFile" v-model="fileName">
                {{fileName}}
                <v-icon right>attach_file</v-icon>
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="fileUpload"
                accept=".xlsx, .xls, .csv"
                @change="onFilePicked"
              />
              <v-spacer></v-spacer>
              <v-btn
                flat
                round
                color="success"
                href="/static/Update_Data_Sim_Template.xlsx"
                target="_blank"
              >
                Tải file mẫu
                <v-icon right>cloud_download</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pa-0">
              <sim-data :isLoading="isLoading" :datasource="simViewModels" />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="cancel()">Nhập lại</v-btn>
              <v-btn color="primary" @click="submit()" :loading="isUpdating">Cập nhật</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import * as Utils from '@/utils';
import XLSX from 'xlsx';
import AppBar from '@/components/appbar';
import SimData from './components/DataList';
import moment from 'moment';
import * as DateTimeUtil from '@/utils/datetime';

export default {
  components: {
    SimData,
    AppBar
  },
  data () {
    return {
      fileName: 'Chọn file',
      simViewModels: [],
      isLoading: false,
      isUpdating: false
    };
  },
  methods: {
    ...mapActions(['updateSimData']),
    pickFile () {
      this.$refs.fileUpload.click();
    },
    onFilePicked (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.parseExcelFileToJson(files[0]);
      }
    },
    parseExcelFileToJson (f) {
      this.isLoading = true;

      this.fileName = `Đã chọn: ${f.name}`;

      let reader = new FileReader();
      reader.readAsBinaryString(f);

      reader.onload = e => {
        let data = e.target.result;
        let workbook = XLSX.read(data, {
          type: 'binary'
        });
        let first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
        let content = XLSX.utils.sheet_to_json(first_worksheet, {
          header: 1
        });

        this.simViewModels = [];

        content.map((item, index) => {
          if (!isNaN(item[0])) {
            if (index > 0) {
              let sim = {
                stt: item[0],
                phone: item[1],
                iccId: item[2] && item[2].startsWith(`'`) ? item[2].substr(1) : item[2],
                activatedDate: item[3],
                data: item[4],
                dataTime: item[5],
              };
              if (sim.iccId && sim.data) {
                this.simViewModels.push(sim);
              }
            }
          }
          return 0;
        });
        this.isLoading = false;
      };
    },
    cancel () {
      window.location.reload();
    },
    submit () {
      if (this.simViewModels.length === 0) {
        window.getApp.showMessage('Không có dữ liệu', 'error');
        return;
      }

      this.isUpdating = true;

      let formattedData = [];
      this.simViewModels.map(a => {
        let item = {
          iccId: a.iccId
        };
        let data = a.data.replace(/,|\.| /g, '');
        if (!isNaN(data) && data > 0) {
          item['data'] = data;
          item['dataTime'] = DateTimeUtil.convertDateTimeToSecond2010(a.dataTime);
          formattedData.push(item);
        }
        return 0;
      });

      this.updateSimData(formattedData)
        .then(res => {
          this.isUpdating = false;
          if (res.success === res.total) {
            window.getApp.showMessage(`Cập nhật thành công ${res.total} sim`);
            window.history.back();
          } else {
            if (res.success > 0) { window.getApp.showMessage(`Cập nhật thành công ${res.success} sim`) }
            if (res.fail > 0) {
              this.simViewModels = res.failList;
              window.getApp.showMessage(`Cập nhật thất bại ${res.fail} sim`, 'error');
            }
          }
        })
        .catch(_ => {
          this.isUpdating = false;
          window.getApp.showMessage(
            'Cập nhật sim thất bại, vui lòng thử lại',
            'error'
          );
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/sim/UpdateData.vue